import { useEffect, useState } from "react";
import { listAbnormalEvents } from "./abnormalApi.js";

/**
 * P166: the six numbers across the top of the Missing Heartbeat monitor.
 *
 * WHY THIS IS NOT THE THING P142B DELETED. That prompt removed KPI tiles that
 * said "รอ Summary API" - placeholders for an aggregate endpoint that does not
 * exist, and the right call was to delete them rather than invent numbers.
 * Nothing has changed about the backend: there is still no summary endpoint.
 * What changed is the method. Every tile here is a REAL server count, read by
 * asking the events list for its own `totalCount` with `pageSize: 1` - the
 * cheapest honest question, and the same technique the Super Agents overview
 * uses. No number on this strip is derived from the rows on screen.
 *
 * The ONE exception is stated plainly, because it is arithmetic rather than a
 * read: the list API has no "exclude this type" filter (which is why the Other
 * Abnormal TAB is honestly labelled page-scoped), so that tile is
 * `total - missingHeartbeat`. Both terms are real server totals over the same
 * filter, so the subtraction is exact - it is not an estimate.
 *
 * The counts follow the SEARCH and the advanced filters, and deliberately
 * ignore the status/type TAB: a strip whose numbers changed every time you
 * clicked one of them could not be used to decide which one to click.
 */
export function useAbnormalSummaryCounts(baseFilters, reloadToken = 0) {
  const [state, setState] = useState({ status: "loading", counts: null });

  useEffect(() => {
    let cancelled = false;
    setState((previous) => ({ status: "loading", counts: previous.counts }));

    const countOf = (extra) =>
      listAbnormalEvents({ ...baseFilters, ...extra, page: 1, pageSize: 1 }).then((data) => data?.totalCount ?? 0);

    Promise.all([
      countOf({}),
      countOf({ status: "Open" }),
      countOf({ status: "Acknowledged" }),
      countOf({ status: "Resolved" }),
      countOf({ abnormalType: "MissingHeartbeat" }),
    ])
      .then(([total, open, acknowledged, resolved, missingHeartbeat]) => {
        if (!cancelled) {
          setState({
            status: "ready",
            counts: {
              total,
              open,
              acknowledged,
              resolved,
              missingHeartbeat,
              // Exact, not estimated - see the note above.
              otherAbnormal: Math.max(0, total - missingHeartbeat),
            },
          });
        }
      })
      .catch(() => {
        // Every tile shows a dash. A zero would be a claim about the data when
        // the truth is a claim about the network, and on this screen "0 Open"
        // is the single most dangerous wrong number there is.
        if (!cancelled) {
          setState({ status: "error", counts: null });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [baseFilters, reloadToken]);

  return state;
}
